<xm-modal-close xmEscKey (escKeyPressed)="close('close')" (onClose)="close('close')"></xm-modal-close>

<div *ngIf="requestStep">
    <form [formGroup]="phoneNumberForm">
        <div class="header">{{ pageData.requestHeader }}</div>
        <div class="subhead">{{ pageData.requestSubhead }}</div>
        <xm-validation class="phone-number" [formCtrl]="phoneNumberFormControl" [options]="phoneNumberOptions">
            <input xmMask xmAriaDescBy xmAriaInvalid formControlName="phoneNumber" defaultAttrType="tel" [id]="phoneNumberOptions.inputId" [template]="phoneNumberOptions.template" />
        </xm-validation>

        <button class="xm-btn-link-light" (click)="close('secondary')">{{ pageData.requestSecondaryButton }}</button>
        <button class="xm-btn-primary-light promise-btn submit" type="submit" (promiseClick)="onSubmit()" [promiseBtn]="submitPromise"><span>{{ pageData.requestPrimaryButton }}</span></button>
        <div *ngIf="apiError" class="error">{{ pageData.requestFailed }}</div>
    </form>
</div>
<div *ngIf="completeStep">
    <div class="header">{{ pageData.completeHeader }}</div>
    <cms-text class="subhead" [originalText]="pageData.completeSubhead"></cms-text>
    <button class="xm-btn-primary-light" (click)="close('primary')">{{ pageData.completePrimaryButton }}</button>
</div>
